import { PlusOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DESC, ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import React, { useCallback, useEffect, useState } from 'react';
import { getPaginationState } from 'react-jhipster';
import { useLocation } from 'react-router-dom';
import { Container } from 'reactstrap';

import { Button, Space } from 'antd';
import Title from 'antd/es/typography/Title';
import TableComponent from 'app/shared/component/table/table';
import { getEntities, reset } from '../projects.reducer';
import { columns } from './config';
import { OrderByType } from 'app/shared/model/enum/order-type.enum';
import ProjectsUpdate from '../form/projects-update';

export const Projects = () => {
    const dispatch = useAppDispatch();

    const pageLocation = useLocation();

    const [paginationState, setPaginationState] = useState(
        overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'lastModifiedDate', DESC), pageLocation.search),
    );

    const projectsList = useAppSelector(state => state.projects.entities);

    const loading = useAppSelector(state => state.projects.loading);
    const totalItems = useAppSelector(state => state.projects.totalItems);

    const [isOpenModalForm, setOpenModalForm] = useState(false);
    const [idSelected, setIdSelected] = useState(null);

    const columnConfig = [
        ...columns,
    ];

    const updateSuccess = useAppSelector(state => state.projects.updateSuccess);

    useEffect(() => {
        dispatch(getEntities({ page: paginationState.activePage, size: paginationState.itemsPerPage, sort: `${paginationState.sort},${paginationState.order}` }));
    }, []);

    useEffect(() => {
        if (updateSuccess && !isOpenModalForm) {
            dispatch(getEntities({ page: paginationState.activePage, size: paginationState.itemsPerPage, sort: `${paginationState.sort},${paginationState.order}` }));
        }
    }, [updateSuccess, isOpenModalForm, paginationState]);

    const handleChange = (pageNumber: number, size: number, sorter: any) => {
        const { order, sort } = paginationState;
        setPaginationState({
            ...paginationState,
            order: Object.keys(sorter).length !== 0 ? (sorter.order && OrderByType[sorter.order] === OrderByType.descend ? DESC : ASC) : order,
            sort: Object.keys(sorter).length !== 0 ? sorter.columnKey : sort,
            activePage: pageNumber,
            itemsPerPage: size,
        });
    };

    const handleOpenModal = (id = null) => {
        setOpenModalForm(true);
        setIdSelected(id);
    };

    const handleCloseModal = useCallback(
        isReload => {
            setOpenModalForm(false);
            setIdSelected(null);
            if (isReload) {
                dispatch(getEntities({ page: paginationState.activePage, size: paginationState.itemsPerPage, sort: `${paginationState.sort},${paginationState.order}` }));
                dispatch(reset());
            }
        },
        [paginationState],
    );
    return (
        <Container className="view">
            <Title level={3}>Danh sách dự án</Title>
            <div className="table">
                <div className="header d-flex justify-content-end">
                    <Space>
                        <Button
                            className="filter"
                            type="primary"
                            onClick={() => {
                                handleOpenModal();
                            }}
                            icon={<PlusOutlined />}
                        >
                            Thêm mới
                        </Button>
                    </Space>
                </div>
                <TableComponent
                    data={projectsList}
                    total={totalItems}
                    isFetching={loading}
                    columns={columnConfig}
                    handlePageChange={(pageNumber: number, size: number, search: any, sorter: any) => {
                        handleChange(pageNumber, size, sorter);
                    }}
                    scroll={true}
                />
            </div>
            <ProjectsUpdate isOpen={isOpenModalForm} id={idSelected} onClose={handleCloseModal} />
        </Container>
    );
};

export default Projects;
